<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">       
    	<el-form :inline="true" class="demo-form-inline backborder1" ref="search" size="small">
		    <el-form-item>
			    <el-select v-model="create.applyid" placeholder="请选择供应商" clearable filterable @change="changeapply">
			    	<el-option v-for="(item,index) in allapplylists" :label="item.apply_name" :value="item.id" :key="index"></el-option>			        
			    </el-select>
		    </el-form-item>		
		    <el-form-item>
		        <el-input placeholder="请输入条形码" v-model="productquery.key" @keyup.enter.native="addDialogsingle">
		          	<template slot="prepend">查找</template>
		          	<el-button slot="append" icon="el-icon-search" @click="addDialogShowsearch"></el-button>
		        </el-input>
		    </el-form-item>
		    <el-form-item>
		        <el-button type="warning" @click="addDialogShow">添加商品</el-button>
		    </el-form-item>
        <el-form-item>
		        <el-tag type="danger">温馨提示：没有入库的商品请将入库数量设置为 0</el-tag>
		    </el-form-item>
		  </el-form>


    <!-- 基础数据信息 -->
		<div class="backborder1" style="margin-top:10px;padding-bottom:10px;position:relative;overflow:hidden;">
        <div class="cz-sell-base-lists-infos-out">
            <div class="cz-sell-base-lists-infos">
              <span class="cz-sell-base-lists-infos-title">单据编号</span>
              <div class="cz-sell-base-lists-infos-content">
                <el-input v-model="create.documents" placeholder="单据编号" :disabled="true"></el-input>
              </div>
            </div>
            <div class="cz-sell-base-lists-infos">
              <span class="cz-sell-base-lists-infos-title">录单日期</span>
              <div class="cz-sell-base-lists-infos-content">
                <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="请选择录单日期" v-model="create.inputdate" style="width:99%;"></el-date-picker>
              </div>
            </div>
            <div class="cz-sell-base-lists-infos">
              <span class="cz-sell-base-lists-infos-title">付款日期</span>
              <div class="cz-sell-base-lists-infos-content">
                <el-date-picker type="date" placeholder="请选择付款日期" v-model="create.paydate" style="width:99%;" value-format="yyyy-MM-dd"></el-date-picker>
              </div>
            </div>
            <div class="cz-sell-base-lists-infos">
              <span class="cz-sell-base-lists-infos-title">收货仓库</span>
              <div class="cz-sell-base-lists-infos-content">
                <el-select v-model="create.warehouse" placeholder="请选择收货仓库" @change="warehouseChange">
                  <el-option v-for="(item,index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select> 
              </div>
            </div>
            <div class="cz-sell-base-lists-infos">
              <span class="cz-sell-base-lists-infos-title">采购人员</span>
              <div class="cz-sell-base-lists-infos-content">
                <el-select v-model="create.clerkid" clearable filterable placeholder="请选采购人员" style="width:100%">
                  <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </div>
            <div class="cz-sell-base-lists-infos">
              <span class="cz-sell-base-lists-infos-title">付款账号</span>
              <div class="cz-sell-base-lists-infos-content">
                <el-select v-model="create.account" placeholder="请选择付款帐号">
                    <el-option v-for="(item,index) in accountLists" :key="index" label="未付款" value="0" v-if="item.id==0"></el-option>
                    <el-option v-for="(item,index) in accountLists" :key="index" :label="item.name" :value="item.id" v-if="item.id > 0"></el-option>
                </el-select>
              </div>
            </div>
            <div class="cz-sell-base-lists-infos">
              <span class="cz-sell-base-lists-infos-title">入库备注</span>
              <div class="cz-sell-base-lists-infos-content">
                <el-input placeholder="备注" v-model="create.note"></el-input>
              </div>
            </div>
            <!-- <div class="cz-sell-base-lists-infos">
              <span class="cz-sell-base-lists-infos-title">配送方式</span>
              <div class="cz-sell-base-lists-infos-content">
                <el-select v-model="create.warehouse" placeholder="请选择配送方式" @change="warehouseChange">
                  <el-option v-for="(item,index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select> 
              </div>
            </div> -->
            <div class="cz-sell-base-lists-infos">
              <span class="cz-sell-base-lists-infos-title">快递公司</span>
              <div class="cz-sell-base-lists-infos-content">
                <el-select v-model="create.express_id" placeholder="请选择物流公司">
                  <el-option v-for="item in logisticsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> 
              </div>
            </div>
            <div class="cz-sell-base-lists-infos">
              <span class="cz-sell-base-lists-infos-title">快递单号</span>
              <div class="cz-sell-base-lists-infos-content">
                <el-input v-model="create.logistics_code" placeholder="请输入物流单号" clearable ></el-input>
              </div>
            </div>
        </div>

        <div class="cz-sell-base-lists-infos-goods">
            <el-table :data="lists" :border="true" v-loading="listLoading" show-summary :summary-method="totalRule">
                <el-table-column prop="name" label="商品信息" min-width="250">
                    <template slot-scope="scope">
                        <span style="float:left;width:100%;font-size:13px;line-height:23px;">{{scope.row.name}}</span>
                        <span style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999" v-if="scope.row.number!=''">编号：{{scope.row.number}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="入库前库存" width="161" align="center">
                    <template slot-scope="scope">
                        <span style="width:100%;font-size:13px;line-height:23px;">{{scope.row.inventory}}</span>
                        <div v-if="goodsLocationStatus">
                          <section v-if="scope.row.storage_location.length>0">
                            (<span v-for="(item_,index) in scope.row.storage_location" :key="index">
                              <span>{{item_.full_code}}</span>
                              <span v-if="item_.numbers">：{{item_.numbers}}</span>
                              <span v-if="index<scope.row.storage_location.length-1&&scope.row.storage_location.length>1">；</span>
                            </span>)
                          </section>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="buy" label="进货价" min-width="140" align="center">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.buy"  @blur="changeBuys(scope.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="num" label="数量" min-width="140" align="center" current-row-key="getindex">
                <template slot-scope="scope">
                    <el-input size="small" v-model="nums[scope.$index]"  @blur="changeNum(scope.$index,scope.row)"></el-input>
                </template>
                </el-table-column>
                <!-- <el-table-column prop="total" label="剩余应入库数" min-width="140" align="center">
                    <template slot-scope="scope">xxx</template>
                </el-table-column> -->
                <el-table-column prop="unit" label="单位" min-width="140" align="center">
                    <template slot-scope="scope">
                      <el-input size="small" :value="scope.row.unit" readonly  @focus="changeUnit(scope.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="total" label="小计" min-width="140" align="center">
                    <template slot-scope="scope">{{scope.row.total|CFMprice}}</template>
                </el-table-column>
                <el-table-column prop="validity" label="收货货位" min-width="155" align="center" v-if="goodsLocationStatus">
                    <template slot-scope="scope">
                        <div class="link-style" @click="showSelectLocation(scope.$index)">
                          <span v-if="!scope.row.storage_location_id">请选择</span>
                          <span v-else>{{ scope.row.full_code || scope.row.storage_location_code }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="validity" label="批次号" min-width="155" align="center" v-if="batchStatus">
                    <template slot-scope="scope">
                        <div class="link-style" @click="switchingBatches(scope.row)">
                          <span>{{scope.row.batch_sn || '请选择批次'}}</span>
                        </div>
                    </template>
                </el-table-column>

                <!-- 旧功能的生产日期 勿删！ -->
                <el-table-column v-if="!batchStatus" prop="validity" label="生产日期" min-width="155" align="center">
                    <template slot-scope="scope">
                        <el-date-picker size="small" type="date" value-format="yyyy-MM-dd" placeholder="生产日期"   v-model="validitys[scope.$index]"  @blur="changeValidity(scope.$index,scope.row)" style="width:99%;"></el-date-picker>
                    </template>
                </el-table-column>

                <!-- 开启批次的生产日期 -->
                <el-table-column v-if="batchStatus" prop="validity" label="生产日期" min-width="155" align="center">
                    <template slot-scope="scope">
                        <el-date-picker size="small" type="date" value-format="yyyy-MM-dd" placeholder="生产日期" v-model="scope.row.start_date"  @change="changeBatch(scope.row, 'start')" style="width:99%;"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="155" align="center" v-if="batchStatus">
                    <template slot-scope="scope">
                      <div style="display: flex;align-items: center;">
                        <el-input size="small" v-model="scope.row.realvalidity" placeholder="有效期"  @input="changeBatch(scope.row, 'realvalidity')"></el-input>
                        <span v-if="scope.row.validityunit == 1">日</span>
                        <span v-if="scope.row.validityunit == 2">月</span>
                        <span v-if="scope.row.validityunit == 3">年</span>
                      </div>
                    </template>
                </el-table-column>
                <el-table-column prop="validity" label="到期日期" min-width="155" align="center" v-if="batchStatus">
                    <template slot-scope="scope">
                        <el-date-picker size="small" type="date" value-format="yyyy-MM-dd" placeholder="到期日期" v-model="scope.row.end_date"  @change="changeBatch(scope.row, 'end')" style="width:99%;"></el-date-picker>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="160" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="" round size="small" @click="delcartCurrent(scope.row)">删除</el-button>
                        <el-button type="" round size="small" @click="copyCurrent(scope.row)">复制</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="cz-sell-order-stat">
				    <div class="cz-sell-order-stat-totals">
            <div style="float:left;width:100%">
                <div class="cz-sell-order-stat-totals-name">
                  <span class="cz-sell-order-stat-totals-name-title">入库合计：￥</span>
                  <span class="cz-sell-order-stat-totals-name-content">{{totalprice}}</span>
                </div>
            </div>
				    </div>
            <div class="cz-sell-order-stat-handles">
                <el-button size="small" type="warning" :loading="addorderLoading" @click="createSave">保存</el-button>
                <el-button size="small" type="warning" :loading="verifyorderLoading" @click="verifySave">确认审核</el-button>
            </div>
			</div>
    </div>
		
		<!---------------------------批量添加--------------------------->
  	   <el-dialog title="添加产品" :visible.sync="addDialog" width="60%" top="1vh">
       	   <el-form :inline="true" class="demo-form-inline" size="small">
	      	  <el-form-item>
	              <el-select v-model="productquery.brandid" clearable filterable placeholder="按品牌" @change="selectbrand">
	              	  <el-option label="不分品牌" value="0" ></el-option>
	              	  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
	              	  	  <span style="float: left">{{item.name}}</span>
      				      <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
	              	  </el-option>
	              </el-select>
	          </el-form-item>
	          <el-form-item>
	              <el-cascader :options="categorylist" v-model="productquery.catid" clearable @change="selectcate"></el-cascader>
	          </el-form-item>
	          <el-form-item ref="productquery" :model="productquery">
	              <el-input placeholder="商品名称 / 编号 / 拼音码 / 条形码" v-model="productquery.key" clearable @keyup.enter.native="getProductList" @change="isnewselect=true"></el-input>
	          </el-form-item>
	          <el-form-item>
	              <el-button type="warning" icon="el-icon-search" @click="getProductList">查询</el-button>
	          </el-form-item>
      	  </el-form>

	      <el-table :data="productlists" style="width: 100%" ref="multipleTable" v-loading="addListLoading" tooltip-effect="dark" @select="handleselectsingle"  @row-click="handleSelectRow" @select-all="handleeditSelectionChange">
	          <el-table-column type="selection" width="50"></el-table-column>
	          <el-table-column prop="name" label="名称">
                <template slot-scope="scope">
                    <span style="float:left;width:100%;font-size:13px;line-height:23px;">{{scope.row.name}}</span>
                </template>
            </el-table-column>
	          <el-table-column prop="number" label="编号" min-width="150" align="center">
                <template slot-scope="scope">
                    <span style="float:left;width:100%;font-size:13px;line-height:23px;">{{scope.row.number}}</span>
                </template>
            </el-table-column>
	      </el-table>
	      <div class="block">
	      	  <!--分页begin-->
	          <el-pagination
	            @size-change="productPageSizeChange"
	            @current-change="productPageCurrentChange"
	            :current-page="productquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="productquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_product_rows">
	          </el-pagination>
	      	  <!--分页end-->
	      </div>
	      <div slot="footer" class="dialog-footer">
	      	  <el-button size="small" @click="addDialog = false">取 消</el-button>
	          <el-button size="small" type="warning" :loading="addProductLoading" @click="addSave">确认添加</el-button>
	      </div>
  	  </el-dialog>
  	  <!--------------------------------批量添加end--------------------------->
  	  
  	  <!---------------------------修改单位--------------------------->
	  <el-dialog title="单位选择" :visible.sync="unitDialog">
	      <el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
		      <el-table-column label="单位" prop="unit"></el-table-column>
		      <el-table-column label="进货价" prop="buy"></el-table-column>
		      <el-table-column label="市场价" prop="market"></el-table-column>
		      <el-table-column label="选择" width="80">
		          <template slot-scope="scope">
		              <el-button type="primary" size="small" icon="el-icon-check"  @click="changeUnitSave(scope.row)"></el-button>
		          </template>
		      </el-table-column>
	      </el-table>
	  </el-dialog>

      <!---------------------------修改货位--------------------------->
      <el-dialog title="选择货位" :visible.sync="locationDialog" @close="locationParams.keyword = ''">
          <el-form :inline="true" class="demo-form-inline" size="small">
	          <el-form-item>
	              <el-input placeholder="请输入搜索关键词" v-model="locationParams.keyword" clearable @keyup.enter.native="getProductList" @change="isnewselect=true"></el-input>
	          </el-form-item>
	          <el-form-item>
	              <el-button type="warning" @click="locationSearch()">查询</el-button>
	          </el-form-item>
      	  </el-form>
          <el-table :data="locationList" style="width: 100%" v-loading="locationDialogLoading">
            <el-table-column label="货位号" align="left" header-align="center" prop="full_code"></el-table-column>
            <el-table-column label="选择" width="80">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" icon="el-icon-check"  @click="selectLocation(scope.row)"></el-button>
                </template>
            </el-table-column>
          </el-table>
          <div class="block">
	      	  <!--分页begin-->
	          <el-pagination
	            @size-change="locationPageSizeChange"
	            @current-change="locationPageCurrentChange"
	            :current-page="locationParams.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="locationParams.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="locationParams.total">
	          </el-pagination>
	      	  <!--分页end-->
	      </div>
      </el-dialog>
    	
      <ChangeBatch ref="ChangeBatch" selectType="2" :editCode="true" :isAll="true" @confirm="batchConfirm" />
    </div>
    </transition>      
</template>

<script>
import ChangeBatch from '@/components/home/ChangeBatch.vue';
export default {
  components: { ChangeBatch },
  props:['childdata'],
  data () {
    return {
      url:this.GLOBAL.domain+"Storage/index",
      transitionshow:true,
      actionauth:[],
      create:{
        act:'add',
        token:this.$cookies.get('token'),
        id:'',
        express_id: '',
        logistics_code: '', // 快递单号
        warehouse:'',
        paydate:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
        account:'',
        documents:'',
        inputdate:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
        note:'',
        status:'',
        applyid:'',
        clerkid:'',
      },
      wareHouseLists:[],
      productquery:{
        act:'lists',
        token:this.$cookies.get('token'),
        brandid:'',
        catid:[],
        applyid:'',
        key:'',
        goodstype:'a0',
        rollpage: 10, // 页大小
        p: 1
      },
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        rollpage: 1000, // 页大小
        p: 1
      },
      lists:[],
      listLoading:false,
      nums:[],
      totals:[],
      validitys:[],
      accountLists:[],
      multipleSelection:[],
      addProductLoading:false,
      addDialog:false,
      brandlists:[],
      unitDialog:false,
      unitListLoading:false,
      changeunitid:0,
      unitlists:[],
      isnewselect:false,
      addListLoading:false,
      total_product_rows:0,
      categorylist:[],
      printsmodel:[],
      rollpage:'',
      verifyorderLoading:false,
      addorderLoading:false,
      delorderLoading:false,
      allapplylists:[],
      sellerLists:[],
      rowclick:false,
      checkboxselect:false,
      totalprice:0.00,
      locationList:[],
      goodsLocationStatus:false,
      locationList:[],
      productlists: [],
      locationDialog: false,
      locationList: [],
      locationDialogLoading: false,
      locationParams: {
        keyword: '',
        rollpage: 10,
        p: 1,
        total: 0
      },
      editListIndex: '',
      batchStatus: false,
      logisticsList: [],
    }
  },

  filters: {
    /** 价格信息保留两位小数 **/
    CFMprice(value) {
       var price=parseFloat(value); //修剪去小数点后多余的0
       var numsobj=price.toString().split(".");	//判断小数点后有几位小数
       var result=0.00;

       if(numsobj.length==1) result=price.toFixed(2); //值为0时补充到2位
       if(numsobj.length > 1 && numsobj[1].length <= 2) result=price.toFixed(2); //值为小数点后只有1位小数时补充到2位
       if(numsobj.length > 1 && numsobj[1].length > 2) result=price; //小数点后的值超出2位时直接返回
       return result;		
    }
  },

  mounted(){
    this.getactionauth(); //获取进货入库按钮的权限
    this.editorder();
    this.setDocuments(); //获取单据编号
    this.getWarehouse(); //获取仓库信息列表
    this.getAccount(); //获取支付信息列表
    this.getCategoryList(); //获取产品分类信息
    this.getprintsmodel(); //获取打印模板
    this.getAllapplylists(); //供应商信息
    this.getSeller(); //获取采购人员信息
    this.checkLocationStatus()
    this.batchStatus = localStorage.getItem('batchStatus') == 'true'
    //获取所有物流快递信息
    this.getallshippinglists();
  },
  methods:{
    //获取所有快递物流信息
    getallshippinglists() {
      // 查询快递公司
      this.$axios({
        url: this.GLOBAL.domain+"Order/index",
        method: 'POST',
        data: {
          act: 'getallshippinglists',
        }
      })
        .then(res => {
          this.logisticsList = res.Data;
        })
    },
    batchConfirm({row, batchRow}) {
      const data = JSON.parse(JSON.stringify(row))
      data.start_date = batchRow.start_date
      data.end_date = batchRow.end_date
      data.realvalidity = batchRow.realvalidity
      data.batch_sn = batchRow.batch_number
      this.batchUpdate(data, batchRow.id)

    },
    changeBatch(row, inputType) {
      // 清除之前的计时器（如果存在）
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }

      // 设置新的计时器，延迟 500ms 执行
      this.debounceTimer = setTimeout(() => {
        // realvalidity

        if (inputType && inputType == 'start' && !row.start_date) {
          row.end_date = ''
        }
        if (inputType && inputType == 'end' && !row.end_date) {
          row.start_date = ''
        }
        

        const realvalidity = !!row.realvalidity && row.realvalidity != '0' ;
        const hasDate = !!(row.start_date || row.end_date);
        const noDete = !!(!row.start_date && !row.end_date);

        if ((realvalidity && hasDate) || (noDete && inputType != 'realvalidity')) {
          // 条件成立
          this.batchUpdate(row)
        }

        
      }, 500)
    },
    async batchUpdate(row, id) {
      try {
          const res = await this.$axios({
            url: this.GLOBAL.domain + 'Storage/index',
            method: 'post',
            data: { 
              act: 'storage_batch_update',
              id: row.id,
              start_date: row.start_date,
              productid: row.productid,
              end_date: row.end_date,
              realvalidity: row.realvalidity,
              validityunit: row.validityunit,
              batch_sn: row.batch_sn,
              batch_storage_inventory_id: id || ''
            }
          });
          // 刷新列表
          this.getList()
          return res;
        } catch (err) {
          console.error('请求异常:', err);
        }
    },
    switchingBatches(row) {
      this.$refs.ChangeBatch.openDialog(row, this.create.warehouse)
    },

    /** 调整数字格式 **/
    changepriceformat(value) { 
        var price=parseFloat(value); //修剪去小数点后多余的0
        var numsobj=price.toString().split(".");	//判断小数点后有几位小数

        if(numsobj.length==1) return price.toFixed(2); //值为0时补充到2位
        if(numsobj.length > 1 && numsobj[1].length <= 2) return price.toFixed(2); //值为小数点后只有1位小数时补充到2位
        if(numsobj.length > 1 && numsobj[1].length > 2) return price; //小数点后的值超出2位时直接返回
    }, 
  
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },
    
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
 
    /** 获取仓库 **/
    getWarehouse(){
        var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
          	    this.$message.error(res.data.Message);
            }else{
          	    this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取银行帐户 **/
    getAccount(){
      var resource = this.$resource(this.GLOBAL.domain+"Account/index");
      resource.query({act:'lists',isnopay:1,token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.accountLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    /** 进货单号 **/
    setDocuments(){
      var resource = this.$resource(this.url);
      resource.query({act:'getjhdocuments',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.create.documents=result;
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    
    editorder() {
    	var item=this.childdata;
      if (!item.id) {
        this.$emit('closechild','Storageedit'); //关闭窗口
        return
      }
        var resource = this.$resource(this.url);
        resource.save({act:'getOrderinfos',id:item.id,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	        	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
            var result=JSON.parse(Base64.decode(res.data.Data));
            console.log(result, '编辑进货入库订单')
	        	this.create.id=result.id;
	        	this.create.warehouse=result.warehouse;
	        	this.create.paydate=result.paydate;
	        	this.create.account=result.account;
	        	this.create.documents=result.documents;
            this.create.express_id = result.logisticsid == '0' ? '' : result.logisticsid;
            this.create.logistics_code = result.shippingcode
	        	this.create.inputdate=result.inputdate;
	        	this.create.status=result.status;
	        	this.create.note=result.note;
	        	this.create.applyid=result.applyid;
	        	this.create.clerkid=result.clerkid;
	        	this.getList();
            // this.locationDropdownList()
	        }    
        }).catch((res) => {
                  
        });
    },
    
    /** 信息列表 **/
    getList(){
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.listLoading = false;
        }else{
            var result = JSON.parse(Base64.decode(res.data.Data));
            this.lists = result.lists
            this.create.applyid=result.applyid;
            if(this.lists!=null) {
              this.lists.forEach((e,index) => {  
                e.buy = this.changepriceformat(e.buy);
                if (!e.storage_location_id) {
                  e.storage_location_id = e.storage_location.length ? e.storage_location[0].storage_location_id : ''
                  e.full_code = e.storage_location.length ? e.storage_location[0].full_code  : ''
                }
                this.changeStorageLocation(e)
                
                this.nums.splice(index, 1, e.num);
                this.totals.splice(index,1,e.total);
                this.validitys.splice(index,1,e.validity);
                
              });
            }
            this.totalprice=result.totals;
            this.total_rows=parseInt(res.data.count);
            this.listLoading = false;
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },


    totalRule() {
        var _this=this;
        var num=0;	    		    	
        this.lists.forEach(function(e,index) {
            num += parseInt(e.num);
		    });

        return ['合计','','',num,'',this.totalprice,'',''];
	  },


    
    /** 扫码添加商品 **/
    addDialogsingle() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({act:'sweep',key:this.productquery.key,applyid:this.create.applyid,goodstype:'a0',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	if(Base64.decode(res.data.Data)==1) { //有1个以上则展开列表 
	        		this.addDialogShow();
	        		this.productquery.key='';
	        	}else { //扫码解析同一个产品只有1个则直接添加
	        		this.multipleSelection=[];
	        		this.multipleSelection.push(JSON.parse(Base64.decode(res.data.Data)));
	        		this.addSave();
	        		this.productquery.key='';
	        	}
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 确认添加商品 **/
    addSave(){
      this.addProductLoading=true;
      var resource = this.$resource(this.url);
      resource.save({
        act:'addproduct',
        productid:this.multipleSelection,
        warehouse_id: this.create.warehouse,
        token:this.$cookies.get('token')
      }).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.addProductLoading=false;
          }else{
            this.$message.success(res.data.Message);
            this.addDialog=false;
            this.addProductLoading=false;
            this.getList();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.addDialog=false;
          this.addProductLoading=false;
      });
    },
    
    /** 批量添加 **/
    addDialogShow(){
      if (!this.create.warehouse) {
        this.$message.error('请先选择收货仓库');
        return
      }
      this.addDialog=true;
      this.getBrand();
      
      this.productquery.brandid='';
      this.productquery.catid=[];
      this.productquery.key='';
      this.productquery.rollpage=10;
      this.productquery.p=1;
      this.multipleSelection=[];
      this.getProductList();
    },
    
    /** 条形码搜索商品信息 **/
    addDialogShowsearch() {
        if (!this.create.warehouse) {
          this.$message.error('请先选择收货仓库');
          return
        }
    	  this.addDialog=true;
        this.getBrand();
      
        this.productquery.brandid='';
        this.productquery.catid=[];
        this.productquery.rollpage=10;
        this.productquery.p=1;
        this.multipleSelection=[];
        this.getProductList();
    },
    
    /** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 修改单位 **/
    changeUnit(item){
        this.unitDialog=true;
        this.unitListLoading = true;
        this.changeunitid=item.id;
        var resource = this.$resource(this.url);
        resource.query({ act:'getunit',productid:item.productid,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	          if(res.data.Result=='70001') this.$router.push('/login')
	          this.$message.error(res.data.Message);
	          this.unitListLoading = false;
	        }else{
	          this.unitlists = JSON.parse(Base64.decode(res.data.Data));
	          this.unitListLoading = false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.unitListLoading=false;
        });
    },
    
    /** 确认修改单位 **/
    changeUnitSave(item){
        this.unitListLoading=true;
        var resource = this.$resource(this.url);
        resource.save({act:'changeunit',id:item.id,tempid:this.changeunitid,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.unitListLoading=false;
            }else{
	            this.unitListLoading=false;
	            this.getList();
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.unitListLoading=false;
        });
        this.unitDialog=false;
    },

    
    /** 修改进货价 **/
    changeBuys(item) {
        this.listLoading=true;
        var resource = this.$resource(this.url);
        resource.save({act:'changeBuy',id:item.id,buy:item.buy,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.listLoading=false;
            }else{
              this.listLoading=false;
              this.getList();
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.listLoading=false;
        });
    },

    
    /** 修改总价 **/
    changeTotal(index,item){
      this.listLoading=true;
      var resource = this.$resource(this.url);
      resource.save({act:'changetotal',id:item.id,total:this.totals[index],token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.listLoading=false;
          }else{
            this.listLoading=false;
            this.getList();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    
    /** 修改数量 **/
    changeNum(index,item){
      this.listLoading=true;
      var resource = this.$resource(this.url);
      resource.save({act:'changenum',id:item.id,num:this.nums[index],token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
            this.listLoading=false;
          }else{
            this.listLoading=false;
            this.getList();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    
    /** 修改有效期 **/
    changeValidity(index,item){
      this.listLoading=true;
      var resource = this.$resource(this.url);
      resource.save({act:'changevalidity',id:item.id,validity:this.validitys[index],token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001'){
              this.$router.push('/login')
            }
            this.$message.error(res.data.Message);
            this.listLoading=false;
          }else{
            this.listLoading=false;
            this.getList();
          }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    
    /** 删除 **/
    delcartCurrent(item){
      this.$confirm('此操作将删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                  }else{
                    this.$message.success('成功删除了' + item.name + '!');
                    this.getList();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
              });
          })
          .catch(() => {
              this.$message.info('已取消操作!');
          });
    },
    
    /** 产品信息列表 **/
    getProductList(){
      if(this.isnewselect==true) {
		  this.productquery.p=1;
		  this.productquery.rollpage=10;	    	
   	  }
    
      this.addListLoading = true;
      this.productquery.applyid=this.create.applyid;
      var resource = this.$resource(this.GLOBAL.domain+"Product/index");
      resource.query(this.productquery).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addListLoading = false;
        }else{
          this.productlists = JSON.parse(Base64.decode(res.data.Data));
          this.total_product_rows=parseInt(res.data.count);
          this.addListLoading = false;
          
          var _this=this;
          var pids=[];
          var number=0;
          this.multipleSelection.forEach(function(e,i) {pids.push(e.id)});	 
          this.productlists.forEach(function(e,i) {
              e.brandname!='' && e.brandname!='无品牌' ? e.name='【'+e.brandname+'】'+e.name : '';
              e.spec!='' ? e.name+=' ['+e.spec+']' : '';

              setTimeout(function() {
                  number=pids.indexOf(e.id);
                  if(number!= -1) _this.$refs.multipleTable.toggleRowSelection(e);
              },100);
          });
          
        }
        
        if(this.isnewselect==true) this.isnewselect=false;
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.addListLoading=false;
          if(this.isnewselect==true) this.isnewselect=false;
      });
    },
    
    
    productPageSizeChange(val) {
        this.productquery.rollpage = val;
        this.getProductList();
    },
    productPageCurrentChange(val) {
        this.productquery.p = val;
        this.getProductList();
    }, 
    
    /** 品牌搜索（品牌发生变化时触发一次搜索） **/
    selectbrand() {
    	this.isnewselect=true;
    	this.getProductList();
    },
    /** 分类搜索（分类发生变化触发一次搜索） **/
    selectcate() {
    	this.isnewselect=true;
    	this.getProductList();
    }, 
    
    
    /** 点击当行checkbox选择商品 **/
    handleselectsingle(val,row) {
    	this.checkboxselect=true;
    	var number=0;
    	var ids=[];
    	this.multipleSelection.forEach(function(e,i) {ids.push(e.id)});
    	number=ids.indexOf(row.id);
    	number==-1 ? this.multipleSelection.push(row) : this.multipleSelection.splice(number,1); 
    	this.checkboxselect=false;
    },
    
    
    /** 点击单行选择产品 **/
    handleSelectRow(row,event,column) {
    	if(this.checkboxselect==true) return false;
    	this.rowclick=true;
    	var number=0;
    	var ids=[];
    	//勾选、取消勾选商品
    	this.$refs.multipleTable.toggleRowSelection(row);
    	this.multipleSelection.forEach(function(e,i) {ids.push(e.id)});
    	number=ids.indexOf(row.id);
    	number==-1 ? this.multipleSelection.push(row) : this.multipleSelection.splice(number,1);   	
    	this.rowclick=false;
    	
    },
    
    handleeditSelectionChange(val) {    
       if(this.rowclick==true) return false;
       var _this=this;
       var ids=[];
       var number=-1;
    	
       if(val.length>0) { //全选时
       	    this.multipleSelection.forEach(function(e,i) {ids.push(e.id)});       
    		val.forEach(function(e,index) {
    			ids.indexOf(e.id)==-1 ? _this.multipleSelection.push(e) : "";
    		})
       }else { //全不选时  
    		this.productlists.forEach(function(e,index) {
    			number=-1;
    			_this.multipleSelection.forEach(function(ee,ii) {number=ii});
    			number > -1 ? _this.multipleSelection.splice(number,1) : "";
    		});
       }
    },
    
    /** 获取产品分类 **/
    getCategoryList() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	          this.categorylist=JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 获取打印模板设置 **/
    getprintsmodel() {
    	var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
        resource.query({ act:'getmodelsetting',id:2,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	          this.printsmodel=JSON.parse(Base64.decode(res.data.Data));
	          this.rollpage=this.printsmodel.pagevalue < 1 ? 10 : this.printsmodel.pagevalue
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 保存订单 **/
    createSave(){
        this.addorderLoading=true;
        var resource = this.$resource(this.url);
        //实时更新单据编号信息
        this.setDocuments();
        this.create.act='add';

        resource.save(this.create).then((res) => {
            if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.addorderLoading=false;
            }else{
              this.$message.success(res.data.Message);
              this.createDialog=false;
              this.addorderLoading=false;
              this.getList();
              this.setDocuments(); //重新获取单据编号
              this.create.id='';
              this.create.warehouse='';
              this.create.account='';
              this.create.note='';
              this.$emit('closechild','Storageedit'); //关闭窗口
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.createDialog=false;
            this.listLoading=false;
        });
    },
    
    
    /** 确认审核订单 **/
    verifySave(){
        this.verifyorderLoading=true;
        var resource = this.$resource(this.url);
        //实时更新单据编号信息
        this.setDocuments();
        this.create.act='verify';
        resource.save(this.create).then((res) => {
            if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.verifyorderLoading=false;
            }else{
              this.$message.success(res.data.Message);
              this.createDialog=false;
              this.addorderLoading=false;
              this.getList();
              this.setDocuments(); //重新获取单据编号
              this.create.id='';
              this.create.warehouse='';
              this.create.account='';
              this.create.note='';
              this.verifyorderLoading=false;
              this.$emit('closechild','Storageedit'); //关闭窗口		
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.createDialog=false;
            this.listLoading=false;
            this.verifyorderLoading=false;
        });
    },
    
    //删除未审核的订单
     delSave() {
     	this.$confirm('您是否确定要删除该进货单, 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              this.delorderLoading=true;
              var resource = this.$resource(this.url);
              resource.save({ act:'delSave',id: this.create.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                      this.delorderLoading=false;
                  }else{
                    this.$message.success('删除入库单成功!');
                    this.delorderLoading=false;
                    this.$emit('closechild','Storageedit'); //关闭窗口		
                  }
              }).catch((res) => {
                  this.delorderLoading=false;
              });
        }).catch(() => {
        	this.$message.info('已取消操作!');
        });
     },
     
     /** 获取全部列表 **/
    getAllapplylists() {
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");        
        resource.query({act:'getapplyAll',token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
                this.$message.error(res.data.Message);;
            }else{
				this.allapplylists=JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
        	
        });
    },
    
    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));
	            //默认选择第一个销售员
	            if(this.sellerLists!='' && this.create.clerkid=='') this.create.clerkid=this.sellerLists[0]['id'];	                      
	        }
        }).catch((res) => {
            
        });
    },
    
    /** 修改供应商信息 **/
    changeapply() {
     	var resource = this.$resource(this.url);
        resource.query({act:'changeapply',token:this.$cookies.get('token'),applyid:this.create.applyid}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.getList();
	        }else{
	                    
	        }
        }).catch((res) => {
            
        });
    },
    warehouseChange(){
      if (this.lists && this.lists.length) {
        const list = JSON.parse(JSON.stringify(this.lists))
        for (const element of list) {
          element["storage_location_id"]=""
          element["full_code"] = ""
          this.changeStorageLocation(element)
        }
        this.getList()
      }
    },
    locationSearch(){
      this.locationParams.p = 1
      this.locationDropdownList()
    },
    locationDropdownList(){
      if (!this.create.warehouse) {
        this.$message.error('请先选择收货仓库')
        return
      }
      const address_url = this.GLOBAL.domain+"StorageLocation/select_list"
      const send_data = {
        warehouse_id: this.create.warehouse,
        token: this.$cookies.get('token'),
        ...this.locationParams
      }
      var resource = this.$resource(address_url);
      this.locationDialogLoading = true
      resource.save(send_data).then((res) => {
        if(res.data.Result>0){
            this.locationList = []
            this.$message.error(res.data.Message);
        }else{
            var result = JSON.parse(Base64.decode(res.data.Data));
            if(Array.isArray(result.data)&&result.data.length>0){
              for (const i of result.data) {
                i["id"]=i["id"].toString()
              }
            }
            this.locationList = result.data
            this.locationParams.total = result.total
        }
      }).catch((res) => {
          this.locationList = []
          this.$message.error(this.GLOBAL.errortext);
      }).finally(() => {
        this.locationDialogLoading = false
      })
    },
    changeStorageLocation(e){
      const address_url = this.GLOBAL.domain+"Storage/index"
      const send_data = {
        act:"changeStorageLocation",
        id:e.id,
        storage_location_id:e.storage_location_id,
        token:this.$cookies.get('token')
      }
      var resource = this.$resource(address_url);
      resource.save(send_data).then((res) => {
        if(res.data.Result>0){
            this.$message.error(res.data.Message);
        }else{
            // var result = JSON.parse(Base64.decode(res.data.Data));
            // console.log(result)
            // *********************
            // this.getList()
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    showSelectLocation(index) {
      this.locationDialog = true
      this.editListIndex = index
      this.locationDropdownList()
    }, 
    selectLocation(row) {
      const list = JSON.parse(JSON.stringify(this.lists))
      list[this.editListIndex] = {
        ...list[this.editListIndex],
        storage_location_id: row.id,
        full_code: row.full_code,
      }
      this.lists = list

      this.locationDialog = false

      this.locationParams.p = 1
      this.locationList = []
      this.changeStorageLocation(this.lists[this.editListIndex])
      
    },
    locationPageSizeChange(val) {
        this.locationParams.rollpage = val;
        this.locationDropdownList();
    },
    locationPageCurrentChange(val) {
        this.locationParams.p = val;
        this.locationDropdownList();
    }, 
    copyCurrent(e){
      const address_url = this.GLOBAL.domain+"Storage/index"
      const send_data = {act:"copy_detail",id:e.id,token:this.$cookies.get('token')}
      var resource = this.$resource(address_url);
      resource.save(send_data).then((res) => {
        if(res.data.Result>0){
            this.$message.error(res.data.Message);
        }else{
            this.getList();
            // var result = JSON.parse(Base64.decode(res.data.Data));
            // console.log(result)
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    checkLocationStatus(){
      const goodsLocationStatus = localStorage.getItem("storageLocationStatus")||''
      if(goodsLocationStatus == "true"){
        this.goodsLocationStatus=true
      }else{
        this.goodsLocationStatus=false
      }      
    }, 
    
  }
}
</script>

<style scoped>
.link-style {
  cursor: pointer;
}
.link-style:hover {
  text-decoration: underline;
  color: #1488f5;
}
</style>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.titlelists {float:left;width:100%;padding:0;margin:0}
.titlelists li {float:left;width:33.3%;font-size:15px;list-style-type:none}
.top1 td {padding-top:5px;font-size:15px}
.top2 td {padding-top:15px;font-size:15px}


.cz-sell-base-lists-infos-out {display:inline-block;width:100%;}
.cz-sell-base-lists-infos {float:left;display:flex;justify-content:left;align-items:center;font-size:0;width:25%;height:50px;overflow:hidden;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-title {float:left;text-align:right;font-size:13px;line-height:23px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content {float:left;margin-left:10px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner {text-align:left;width:220px;border-bottom:1px solid #dcdfe6;border-top:none;border-left:none;border-right:none;border-radius:0;height:40px;line-height:40px;font-size:13px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner:hover {box-shadow:none;border-bottom:1px solid #dcdfe6;}
.cz-sell-base-lists-infos .el-input.is-active .el-input__inner, .cz-sell-base-lists-infos .el-input__inner:focus {border-color:#dcdfe6 !important;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-checkbox__inner {margin-top:7px}

.cz-sell-base-lists-infos-goods {display:inline-block;width:100%;margin-top:20px;}
.cz-sell-base-lists-infos-goods .el-table {font-size:13px;}
.cz-sell-base-lists-infos-goods .el-table th.is-leaf {background:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table td, .cz-sell-base-lists-infos-goods .el-table th.is-leaf {border-bottom:1px solid #E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table .el-table_body tr,.cz-sell-base-lists-infos-goods .el-table .hover-row > td {background-color:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table__fixed-footer-wrapper tbody td {background:#E4E7ED;border-bottom:1px solid #E4E7ED;}
.cz-sell-base-lists-infos-goods .el-input__inner {overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;border-bottom:none;border-top:none;border-left:none;border-right:none;border-radius:15px;height:32px;line-height:32px;font-size:13px;}
.cz-sell-base-lists-infos-goods .el-input__inner:hover {box-shadow:none;border:none;}
.cz-sell-base-lists-infos-goods .el-table__footer-wrapper tbody td, .cz-sell-base-lists-infos-goods .el-table__header-wrapper tbody td {background-color:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table--enable-row-hover .el-table__body tr:hover>td {background-color:#E4E7ED;}
.cz-sell-order-stat {width:calc(100%);height:100px;position:relative;margin-top:10px;margin-bottom:20px;background:none;display:flex;justify-content:center;align-items:center;}
.cz-sell-order-stat-handles {padding:10px 20px;height:60px;border-left:1px solid #EBEEF5;width:30%;display:flex;justify-content:left;align-items:center;overflow:hidden;}
.cz-sell-order-stat-totals {padding:10px 20px;height:100px;width:calc(100% - 30% - 40px - 40px - 1px);display:flex;justify-content:left;align-items:center;overflow:hidden;}
.cz-sell-order-stat-totals-name {float:left;width:calc(25% - 30px) !important;padding:3px 30px 0 0 !important;font-size:13px;}
.cz-sell-order-stat-totals-name-title {float:left;width:80px;}
.cz-sell-order-stat-totals-name-content {float:left;width:calc(100% - 100px - 10px - 30px);padding:0 15px;color:red;font-weight:550;font-size:14px;}

.cz-sell-order-stat-totals-name .el-input {width:calc(100% - 80px - 5px);font-size:14px;}
.cz-sell-order-stat-totals-name .el-input__inner {color:red;font-weight:550;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;border-bottom:1px solid #c0c4cc !important;border-top:none;border-left:none;border-right:none;border-radius:0;height:32px;line-height:32px;font-size:13px;background:none;text-align:left;}
.cz-sell-order-stat-totals-name .el-input__inner:hover {box-shadow:none;border:none;border-bottom:1px solid #c0c4cc !important;background:none;}
.cz-sell-order-stat-totals-name .el-input.is-active .el-input__inner, .cz-sell-order-stat-totals-name .el-input__inner:focus {border-color:#c0c4cc !important;background:none;}

.cz-sell-order-sort {background:#fff;width:98%;float:left;margin-top:10px;padding:1% 1% 1% 1%;border-radius:5px;}
.cz-sell-order-sort .dargDiv {float:left;width:100%;border-bottom:1px dashed #dddddd;font-size:14px;line-height:23px}
.cz-sell-order-sort .dargDiv .cz-sell-order-sort-infos {color:#666666;cursor:pointer;font-size:13px;float:left;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
.cz-sell-order-sort .dargDiv:hover {background:rgb(254, 240, 240);}


.cz-sell-base-lists-infos-goods .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar {width:10px;height:10px;}
.cz-sell-base-lists-infos-goods .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 5px rgba(220,223,230,0.2);background: rgba(96,98,102,0.4);}
.cz-sell-base-lists-infos-goods .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 5px rgba(153,153,153,0.2);border-radius: 0;background: rgba(153,153,153,0.1);}

</style>


// WEBPACK FOOTER //
// src/components/purchase/Storageedit.vue